import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

import * as stores from '../../stores';
import { IQueryableRouteComponentProps } from 'easit--routing';
import { goBack } from '../../../../routing/routing';
import { TicketDetailForVGStore, evalFooterVisibility } from 'eTip--common';

import { SimpleBarWrapper as SimpleBar, TicketDetailForVG } from 'desktop--design-library';
import { FooterContainer } from '../footer/footerContainer';

import { translation } from 'easit--localization';

export interface ITicketDetailForVGQueryParams {
    ticketId?: string;
}

export interface ITicketDetailForVGContainerProps extends IQueryableRouteComponentProps<ITicketDetailForVGQueryParams, {}> {
    applicationStore?: IAppStoreWithTicketDetailForVG;
}

export interface IAppStoreWithTicketDetailForVG {
    ticketForVG: Instance<typeof TicketDetailForVGStore>;
}

export abstract class TicketDetailForVGContainerBase extends React.Component<ITicketDetailForVGContainerProps> {
    constructor(props: ITicketDetailForVGContainerProps) {
        super(props);
    }

    abstract loadDataAsync(): Promise<void>;

    componentWillMount() {
        this.loadDataAsync();
    }

    get detailStore() {
        return this.props.applicationStore.ticketForVG;
    }

    render() {
        return <SimpleBar className="h-100" forceVisible={true} scrollToTop>
            <TicketDetailForVG
                shouldGoHomeOnBack={false}
                dateCreated={this.detailStore.placementDate}
                prizePaidDate={this.detailStore.paidDate}
                possiblePayout={this.detailStore.potentialWin}
                winPaid={this.detailStore.winToPay}
                finalWin={this.detailStore.finalWin}
                finalRate={this.detailStore.rate}
                ticketType={this.detailStore.ticketType}
                stake={this.detailStore.stake}
                stakePoints={null}
                handlingFee={null}
                handlingFeePoints={null}
                ticketState={this.detailStore.ticketState}
                evalState={this.detailStore.evalState}
                number={this.detailStore.number}
                customerNickName={this.detailStore.customerNickName}

                state={this.detailStore.state}
                error={this.detailStore.error}

                selections={this.detailStore.selections}

                productFee={null}
                productName={null}
                oddsRateAdvantage={null}
                rateAdvantageFactor={null}

                title={translation().ticket_detail}
                goBack={goBack}
                refresh={() => this.loadDataAsync()}
            />
            <FooterContainer canShow={evalFooterVisibility(this.detailStore.state)} />
        </SimpleBar>
    }
}

export abstract class TicketDetailMyTicketForVGBaseContainer extends TicketDetailForVGContainerBase {

    get ticketId(): string {
        return this.props.match.params.ticketId;
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.match.params.ticketId != nextProps.match.params.ticketId) {
            this.detailStore.loadMyTicketAsync(nextProps.match.params.ticketId);
        }
    }

    loadDataAsync(): Promise<void> {
        return this.detailStore.loadMyTicketAsync(this.ticketId);
    }
}

@inject(stores.ApplicationStoreKey)
@observer
export class TicketDetailMyTicketForVGContainer extends TicketDetailMyTicketForVGBaseContainer {
}
